import Axios from "axios";

const api = require("../api/api-config");

export function getSubjects() {
  Axios.defaults.headers.common = {
    Authorization: `Bearer ${localStorage.getItem("token")}`
  };
	return Axios.get(`${api.api}/subjects`);
}